// extracted by mini-css-extract-plugin
module.exports = {"countdown":"_i","srOnly":"aj"};